// Typography for a rendered blog article. Shared by the public article page and
// the admin preview so what the editor previews is exactly what readers see.
//
// flow-root contains images floated by the editor's "wrap text" option, so they
// cannot hang out past the end of the article into the share bar. On phones a
// wrapped image would squeeze the text into a sliver, so it drops back to a
// full-width block there.
export const ARTICLE_PROSE_CLASSES = [
  'prose prose-lg max-w-none flow-root',
  'prose-headings:text-gray-900 prose-headings:font-bold prose-h2:mt-12 prose-h2:mb-4 prose-h3:mt-8 prose-h3:mb-3',
  'prose-p:text-gray-700 prose-p:leading-relaxed',
  'prose-a:text-pink-600 prose-a:underline prose-a:font-medium [&_a_strong]:!text-pink-600 [&_a_em]:!text-pink-600',
  'prose-strong:text-gray-900',
  'prose-blockquote:border-l-4 prose-blockquote:border-pink-300 prose-blockquote:bg-pink-50/40 prose-blockquote:py-2 prose-blockquote:px-6 prose-blockquote:rounded-r-lg prose-blockquote:not-italic prose-blockquote:text-gray-700',
  'prose-li:my-1 prose-img:rounded-xl prose-img:shadow-sm prose-figure:my-8 prose-hr:border-gray-200 prose-hr:my-10',
  'max-sm:[&_img[style*=float]]:!float-none max-sm:[&_img[style*=float]]:!w-full max-sm:[&_img[style*=float]]:!mx-0',
].join(' ');

const normaliseTitle = (text) =>
  (text || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&[a-z#0-9]+;/gi, ' ')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

// Articles pasted in from a chat tool or another editor often open with the
// title as a heading. The page already prints the title above the cover, so
// that heading shows it twice. Drop a leading heading (after any empty
// paragraphs) whose text matches the title; any other opening line stays.
export const stripRepeatedTitle = (html, title) => {
  const wanted = normaliseTitle(title);
  if (!html || !wanted) return html || '';
  const match = html.match(
    /^(\s|<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>)*<(h[1-6])[^>]*>([\s\S]*?)<\/\3>/i
  );
  if (!match || normaliseTitle(match[4]) !== wanted) return html;
  return html.slice(match[0].length).trimStart();
};
